import {Injectable} from '@angular/core';
import {User} from "../classes/user";
import {ISecureToken, IUserAccount} from "../interfaces/user";
import {IAddress} from "../interfaces/address";
import {IOrder} from "../interfaces/order";
import * as STORAGE from "../constants/storage";
import {Product} from "../classes/product";
import {Http, Response} from "@angular/http";
import {API} from "./api.service";
import {Observable} from "rxjs";
import {ICouponPayload} from "../interfaces/coupons";
import {Coupon} from "../classes/coupon";
import {StorageService} from "./storage.service";

@Injectable()
export class UserService {
  constructor(private http : Http, private storage: StorageService) {}

  get(): Promise<User> {
    return new Promise((resolve, reject) => {
      Promise.all([
        this.getSecureToken(),
        this.getAddresses(),
        this.getOrders(),
        this.getAccount()])
        .then((values: any) => {
          const [secureToken, addresses, orders, account] = values;
          const user = new User({
            secureToken,
            addresses,
            orders,
            account
          });
          resolve(user);
        })
        .catch(reject);
    });
  }

  getUserOrders(){
    return new Promise((resolve, reject) => {
      this.getAccount().then((account) => { // get account data
        if (!account || !account.phonenumber) {
          return resolve([]);
        }
        let phonenumber = account.phonenumber;

        this.http.get(
          `${API.BASE_HOST}/customers/${API.CUSTOMER}/orders/?from=${phonenumber}`
        ).map(this.parseOrders).subscribe(
          orders => resolve(orders),
          err => reject(err)
        );
      });
    });
  }

  parseOrders(req : Response){
    return req.json();
  }

  getCoupons() : Promise<Coupon[]> {
    return new Promise((resolve, reject) => {
      this.getAccount().then((account) => { // get account data
        if (!account){
          return resolve([]);
        }
        let phonenumber = account.phonenumber;

          this.http.post(
            `${API.BASE_HOST}/customers/${API.CUSTOMER}/modules/coupons/view/`, {phonenumber}
          ).map(this.parseCoupons).subscribe(
            coupons => resolve(coupons),
            err => reject(err)
          );
      });
    });
  }

  parseCoupons(req : Response){
    return req.json().map((couponPayload : ICouponPayload) => {
      return new Coupon(couponPayload);
    })
  }

  getFavorites(): Promise<Product[]> {
    return new Promise((resolve, reject) => {
      this.storage.get(STORAGE.USER_FAVORITES_STORAGE).then((result) => {
        if (!result) {
          result = []
        }
        resolve(result.map((r) => {
          const product = new Product(r[0], r[1]);
          product.setIdentifier();
          return product;
        }));
      }, reject);
    });
  }

  addFavorite(product: Product) {
    product.setIdentifier();
    this.getFavorites().then((favorites) => {
      favorites.push(product);
      this.setFavorites(favorites);
    })
  }

  setFavorites(favorites: Product[]) {
    this.storage.set(STORAGE.USER_FAVORITES_STORAGE, favorites.map((f) => {
      return [f.getPayload(), f.getCategory()]
    }));
  }

  removeFavorite(product: Product) {
    this.getFavorites().then((favorites) => {
      this.setFavorites(favorites.filter((f) => {
        return f.number !== product.number
      }));
    });
  }

  getSecureToken(): Promise<ISecureToken> {
    return this.storage.get(STORAGE.USER_SECRET_STORAGE);
  }

  setSecureToken(secureToken) {
    return this.storage.set(STORAGE.USER_SECRET_STORAGE, secureToken)
  }

  getAddresses(): Promise<IAddress[]> {
    return this.storage.get(STORAGE.USER_ADDRESS_STORAGE);
  }

  getOrders(): Promise<IOrder[]> {
    return this.storage.get(STORAGE.USER_ORDERS_STORAGE);
  }

  getAccount(): Promise<IUserAccount> {
    return this.storage.get(STORAGE.USER_ACCOUNT_STORAGE);
  }

  setAccount(payload) {
    return this.storage.set(STORAGE.USER_ACCOUNT_STORAGE, payload)
  }
}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts